import translation from "./translation.json";
import admin from "./admin.translation.json";
import elsa from "./elsa.translation.json";
import CookiesSummarySnippet from "./cookies-summary";

const snippets = {
  CookiesSummary: CookiesSummarySnippet,
};

export default {
  translation,
  admin,
  elsa,
  snippets,
};
